import { Text, View } from 'react-native';
import type { AbaId } from '../store/types';
import { setDoc } from '../store/store';
import { Btn, Screen } from '../components/ui';
import { Assinar, AvisoAssinatura, usePrecos } from '../components/Assinar';
import { C, aba, alpha, useCores } from '../components/theme';
import { cobrancaAtiva, DIAS_TESTE_ABA, MESES_TESTE_BASICO, PRECO_ABA_USD, PRECO_BASICO_USD, precoTexto } from '../lib/plano';
import { moedaPadrao } from '../lib/moeda';
import { brYmd, today } from '../lib/date';
import { t } from '../lib/i18n';

const comecarTeste = (id: AbaId) => setDoc('ajustes', d => ({ ...d, testes: { ...(d.testes ?? {}), [id]: today() } }));

/** Tela de aba bloqueada: teste grátis de 10 dias ou assinatura. A compra pela Google Play / App Store entra na fase das lojas. */
export default function Paywall({ id, onBack }: { id: AbaId; onBack: () => void }) {
  const a = aba(id);
  const { situacao } = useCores();
  const s = situacao(id);
  const precos = usePrecos([id]);
  const preco = precos[id] || precoTexto(a.gratis ? PRECO_BASICO_USD : PRECO_ABA_USD, moedaPadrao());
  return (
    <Screen title={a.nome} onBack={onBack}>
      <View style={{ alignItems: 'center', gap: 14, marginTop: 30 }}>
        <View style={{ width: 110, height: 110, borderRadius: 55, backgroundColor: alpha(a.cor, 0.18), alignItems: 'center', justifyContent: 'center' }}>
          <Text style={{ fontSize: 56 }}>{a.icon}</Text>
        </View>
        <Text style={{ color: C.text, fontSize: 22, fontWeight: '800', textAlign: 'center' }}>
          {s.tipo === 'teste-disponivel' ? t('Experimente grátis por {n} dias', { n: DIAS_TESTE_ABA }) : '🔒 ' + t('O teste grátis terminou')}
        </Text>
        <Text style={{ color: C.sub, textAlign: 'center', fontSize: 15 }}>{a.desc}</Text>
        {s.tipo === 'vencida' && <Text style={{ color: C.sub, textAlign: 'center', fontSize: 13 }}>{t('Terminou em {data}. Nada foi apagado: tudo volta como estava ao assinar.', { data: brYmd(s.desde) })}</Text>}
        <View style={{ backgroundColor: C.card, borderRadius: 14, padding: 14, alignSelf: 'stretch', gap: 4 }}>
          <Text style={{ color: C.text, fontWeight: '800', textAlign: 'center' }}>{t('{preco} por ano', { preco })}</Text>
          {!precos[id] && <Text style={{ color: C.mute, fontSize: 11, textAlign: 'center' }}>{t('Valor final definido pela loja de apps, já na moeda do seu país.')}</Text>}
        </View>
      </View>
      {s.tipo === 'teste-disponivel' && <Btn cor={a.cor} label={t('Começar o teste grátis')} style={{ marginTop: 20 }} onPress={() => comecarTeste(id)} />}
      <Assinar id={id} cor={a.cor} outline={s.tipo === 'teste-disponivel'} preco={precos[id]} style={{ marginTop: 10 }} />
      <View style={{ marginTop: 10 }}><AvisoAssinatura /></View>
    </Screen>
  );
}

/** Aviso de fim do período grátis do plano básico (My Planner + Anotações). */
export function PlanoBasicoVencido({ onAjustes }: { onAjustes: () => void }) {
  const precos = usePrecos(['planner']);
  const preco = precos.planner || precoTexto(PRECO_BASICO_USD, moedaPadrao());
  return (
    <View style={{ flex: 1, backgroundColor: C.bg, padding: 24, justifyContent: 'center', gap: 14 }}>
      <Text style={{ fontSize: 48, textAlign: 'center' }}>📅</Text>
      <Text style={{ color: C.text, fontSize: 22, fontWeight: '800', textAlign: 'center' }}>{t('Seus {n} meses grátis terminaram', { n: MESES_TESTE_BASICO })}</Text>
      <Text style={{ color: C.sub, textAlign: 'center' }}>{t('Continue usando o My Planner e as Anotações por {preco} por ano. Seus dados continuam guardados.', { preco })}</Text>
      <Assinar id="planner" cor="#8B5CF6" preco={precos.planner} />
      <AvisoAssinatura />
      <Btn cor="#8B5CF6" outline label={t('Ir para Ajustes (exportar meus dados)')} onPress={onAjustes} />
    </View>
  );
}
